/**
 * Defines selectors related to user entitled apps.
 */
export default (state) => {
  const { UserEntitledApps = {}, SideBar } = state;
  const {
    thirdPartyAppList = [],
    showToast,
    errorToastMessage,
    thirdPartyAppsFetched = false,
  } = UserEntitledApps;
  const {
    userDetails, userDetailsFetched,
  } = SideBar;

  return {
    // Guard: backend / hydration may briefly supply a non-array; UI expects []. #genai
    thirdPartyAppList: Array.isArray(thirdPartyAppList) ? thirdPartyAppList : [],
    userDetails,
    showToast,
    errorToastMessage,
    userDetailsFetched,
    thirdPartyAppsFetched,
  };
};
